module["exports"] = ["Постач", "Торг", "Пром", "Трейд", "Збут"];